import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=34eff260&scoped=true&"
import script from "./shopDetail.vue?vue&type=script&lang=ts&"
export * from "./shopDetail.vue?vue&type=script&lang=ts&"
import style0 from "./shopDetail.vue?vue&type=style&index=0&id=34eff260&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eff260",
  null
  
)

export default component.exports